import React from "react";
import { useIntl } from "react-intl";
import { Menu, Select, MenuButton, MenuList, MenuItem } from "@chakra-ui/react";

const getPayoutOptionStr = (payoutOption, formatMessage) => {
  const minDays = payoutOption.minimum_business_days;
  const maxDays = payoutOption.maximum_business_days;
  const feePercent = payoutOption.fee_percentage;

  // get the day range and add it to the return string
  if (minDays === maxDays) {
    if (minDays === 0) {
      return formatMessage(
        {
          // defaultMessage: "Same day | {feePercent}% fee",
          defaultMessage: "{feePercent}% fee", // TODO: temporarily removing timing info
          description: "Fee percentange description",
        },
        {
          feePercent,
        }
      );
    } else if (minDays === 1) {
      return formatMessage(
        {
          // defaultMessage: "1 day | {feePercent}% fee",
          defaultMessage: "{feePercent}% fee", // TODO: temporarily removing timing info
          description: "Fee percentange description",
        },
        {
          feePercent,
        }
      );
    } else {
      return formatMessage(
        {
          // defaultMessage: "{minDays} days | {feePercent}% fee",
          defaultMessage: "{feePercent}% fee", // TODO: temporarily removing timing info
          description: "Fee percentange description",
        },
        {
          feePercent,
          minDays,
        }
      );
    }
  } else {
    return formatMessage(
      {
        // defaultMessage: `{minDays}-{maxDays} days | {feePercent}% fee`,
        defaultMessage: `{feePercent}% fee`, // TODO: temporarily removing timing info
        description: "Fee percentange description",
      },
      {
        feePercent,
        minDays,
        maxDays,
      }
    );
  }
};

/**
 * PayoutOptionSelector - Component to select payout options for a payment method.
 * @param {PayoutOptionSelectorProps} props
 * @param {Object} props.paymentMethod - the payment method that this component is responsible for.
 * @param {Object} props.selectedPayoutOption - the current payout option selected.
 * @param {Function} props.onSelect - callback function selection is performed. It will return the entire payout option object.
 * @returns JSX.Element
 */
const PayoutOptionSelector = ({ paymentMethod, selectedPayoutOption, onSelect }) => {
  const { formatMessage } = useIntl();
  const displayString = selectedPayoutOption
    ? getPayoutOptionStr(selectedPayoutOption, formatMessage)
    : "";

  // Select & option components are used for styling only
  return (
    <Menu>
      <MenuButton
        onClick={(e) => e.stopPropagation()}
        type="button"
        data-testid="payout-option-selector-menu-button"
      >
        <Select background="background">
          <option data-testid="selected-payout-option">{displayString}</option>
        </Select>
      </MenuButton>
      <MenuList>
        {paymentMethod.payoutOptions.map((payoutOption) => (
          <MenuItem
            key={`payment-method-${paymentMethod.id}-payout-option-${payoutOption.display_name}`}
            data-testid={`payout-option-${payoutOption.display_name}`}
            value={payoutOption.display_name}
            onClick={(e) => {
              e.stopPropagation();
              onSelect(payoutOption);
            }}
          >
            {getPayoutOptionStr(payoutOption, formatMessage)}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default PayoutOptionSelector;
